import { BlobProvider } from '@react-pdf/renderer'
import { Button } from 'react-bootstrap'

import styles from './styles.module.css'

const DownloadPDFButton = ({ document, fileName = 'report.pdf', text = 'Baixar PDF' }) => {
  return (
    <BlobProvider document={document}>
      {({ url, loading }) =>
        loading ? (
          'Carregando documento...'
        ) : (
          <Button href={url} download={fileName} target="_blank" className={styles.pdfButton}>
            {text}
          </Button>
        )
      }
    </BlobProvider>
  )
}

export default DownloadPDFButton
